import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  CheckBox,
  FormInput,
  FormSelect,
  FormTemplate,
  FormTextArea,
  FormsSelect,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import Table from "../../../Components/Table/Table";
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
// import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
import {
  UpdateAuxiliaryServiceRequest,
  GetAllAuxiliaryServiceSetup,
  SubmitAuxiliaryServiceRequest,
  GetAuxiliaryServiceRequestById,
} from "../../../../../utils/redux/HR/HRSlice";
import {
  FormatDateTime,
  removeListData,
} from "../../../../../utils/functions/ResourceFunctions";
import FormUploadComponent from "../../../Components/Forms/FormUploadComponent";
import { TableActionsDownload } from "../../../Components/Misc/Actions";
import { toast } from "react-toastify";

function UpdateAuxiliaryRequest() {
  const [uploadFile, setUploadFile] = useState(null);
  const [vendorDocument, setVendorDocument] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { auxiliary_service_setup } = useSelector((state) => state?.hr);
  const getRequest = useSelector((state) => state?.hr);
  const { auxiliary_service_request_by_id, isLoading } = getRequest;
  const updatedData = auxiliary_service_request_by_id?.result;

  console.log("updatedData", updatedData);

  const defaultData = {
    
    ServiceId: updatedData?.auxiliaryServiceTypeId,
    assetName: updatedData?.assetName,
    paymentMode: Number(updatedData?.paymentMode),
    serialNumber: updatedData?.serialNumber,
    registrationNumber: updatedData?.registrationNumber,
    purchasedDate: updatedData?.dateBought
      ? new Date(updatedData.dateBought).toISOString().split("T")[0]
      : null,
    costOfAsset: Number(updatedData?.costOfAsset),
    insuredAmount: updatedData?.insuredAmount,
    deductibleAmount: updatedData?.deductibleAmount,
    periodOfDeduction: updatedData?.periodOfDeduction,
    numberOfBottles: updatedData?.numberOfBottles,
    isDeductibleOnce: updatedData?.isDeductibleOnce,
    balance: updatedData?.balance,
    rate: updatedData?.rate,
    percentageValue: updatedData?.percentageValue,
    evidenceOfPayment: {
      file: null,
      fileName: "",
      documentType: "",
      contentType: "",
    },
    other: {
      file: null,
      fileName: "",
      documentType: "",
      contentType: "",
    },
  };

  const formMethods = useForm({
    defaultValues: defaultData,
    mode: "all",
  });

  const {
    handleSubmit,
    formState: { isValid },
    watch,
    reset,
    setValue,
  } = formMethods;

  // Reset form when updatedData is available
  useEffect(() => {
    if (updatedData) {
      reset({
        ServiceId: updatedData?.auxiliaryServiceTypeId,
        assetName: updatedData?.assetName,
        paymentMode: Number(updatedData?.paymentMode),
        serialNumber: updatedData?.serialNumber,
        registrationNumber: updatedData?.registrationNumber,
        purchasedDate: updatedData?.dateBought
          ? new Date(updatedData.dateBought).toISOString().split("T")[0]
          : null,
        costOfAsset: Number(updatedData?.costOfAsset),
        insuredAmount: updatedData?.insuredAmount,
        deductibleAmount: updatedData?.deductibleAmount,
        periodOfDeduction: updatedData?.periodOfDeduction,
        numberOfBottles: updatedData?.numberOfBottles,
        isDeductibleOnce: updatedData?.isDeductibleOnce,
        balance: updatedData?.balance,
        rate: updatedData?.rate,
        percentageValue: updatedData?.percentageValue,
        evidenceOfPayment: {
          file: null,
          fileName: updatedData?.evidenceOfPayment?.fileName || "",
          documentType: updatedData?.evidenceOfPayment?.documentType || "",
          contentType: updatedData?.evidenceOfPayment?.contentType || "",
        },
        other: {
          file: null,
          fileName: updatedData?.other?.fileName || "",
          documentType: updatedData?.other?.documentType || "",
          contentType: updatedData?.other?.contentType || "",
        },
      });
    }
  }, [updatedData, reset]);

  // Function to convert file to base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1]; // Split to remove the data prefix
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const paymentModes = [
    { value: 0, name: "One Off" },
    { value: 1, name: "Salary Deduction" },
    { value: 2, name: "Part Payment" },
  ];

  const serviceType = [
    { id: 1, title: "CWAY" },
    { id: 2, title: "INSURANCE" },
  ];

  const payloadAuxiliaryServiceSetup = {
    pageNumber: 1,
    perPage: 10000,
    ApprovalStatus: 411,
  };

  const documentList = [
    {
      value: 105,
      name: "Evidence Of Payment",
    },
  ];

  const [selectedAssetDetails, setSelectedAssetDetails] = useState(null);

  const ServiceId = watch("ServiceId"); // Watching for Service Type selection
  const selectedPaymentMode = Number(watch("paymentMode"));

  const typeOfAuxiliaryService = auxiliary_service_setup?.result?.filter(
    (x) => x?.typeOfAuxiliaryService === 1
  );
console.log('type of auxiliary service', typeOfAuxiliaryService)
  const typeOfAuxiliaryServiceInsurance =
    auxiliary_service_setup?.result?.filter(
      (x) => x?.typeOfAuxiliaryService === 2
    );

  const amount =
    typeOfAuxiliaryService &&
    typeOfAuxiliaryService[0]?.rate * watch("numberOfBottles");

  const paymentDeadline =
    typeOfAuxiliaryService && typeOfAuxiliaryService[0]?.paymentDeadline;

  const formattedPaymentDeadline = paymentDeadline
    ? new Date(paymentDeadline).toISOString().split("T")[0]
    : "";

  // Insured Amount = approved percentage value in #384 * Cost of Asset
  const calculateInsuredAmount =
    (selectedAssetDetails?.percentageValue / 100) *
    Number(watch("costOfAsset"));

  const calculatePeriodOfDeduction = selectedAssetDetails?.periodOfDeduction;

  // Deductible Amount = Insured Amount/approved Period of Deduction
  const calculatedDeductibleAmount =
    calculateInsuredAmount / calculatePeriodOfDeduction;

  const getAssetDetails = (assetName) => {
    return typeOfAuxiliaryServiceInsurance?.find(
      (x) => x?.assetName == assetName
    );
  };

  useEffect(() => {
    if (ServiceId === 1) {
      setValue("amount", amount);
      setValue("paymentDeadline", formattedPaymentDeadline);
    }

    if (ServiceId === 2) {
      setValue("insuredAmount", calculateInsuredAmount);
      setValue("deductibleAmount", calculatedDeductibleAmount);
      setValue("periodOfDeduction", calculatePeriodOfDeduction);
      setSelectedAssetDetails(
        getAssetDetails(watch("assetName")) || selectedAssetDetails
      );
    }
  }, [
    selectedAssetDetails,
    ServiceId,
    setValue,
    amount,
    formattedPaymentDeadline,
    calculateInsuredAmount,
    calculatedDeductibleAmount,
    calculatePeriodOfDeduction,
  ]);

  const submit = async (data) => {
    try {
      const updatedVendorDocuments = await Promise.all(
        vendorDocument?.map(async (document) => {
          if (document?.file) {
            try {
              const base64File = await fileToBase64(document.file);
              return {
                ...document,
                file: base64File,
                fileName: document.file.name,
                documentType: Number(document?.fileName),
                contentType: document.file.type || "application/octet-stream",
              };
            } catch (error) {
              console.error("Error converting file to base64:", error);
              return {
                ...document,
                file: null,
              };
            }
          }
          return {
            ...document,
            documentType:
              documentList.find((d) => d.value === document.documentType)
                ?.name || "UNKNOWN",
            contentType: document.contentType || "application/octet-stream",
          };
        })
      ); 
console.log('updated vendor document', updatedVendorDocuments)
      let dataValues = {
        id: Number(id),
        auxiliaryServiceTypeId: updatedData?.auxiliaryServiceTypeId,
        // auxiliaryServiceTypeId:
        //   data?.ServiceId === 1
        //     ? typeOfAuxiliaryService[0]?.id * 1
        //     : selectedAssetDetails?.id * 1,
        assetName: data?.assetName,
        paymentMode: Number(data?.paymentMode),
        serialNumber: data?.serialNumber,
        registrationNumber: data?.registrationNumber,
        purchasedDate: data?.purchasedDate,
        costOfAsset: Number(data?.costOfAsset),
        insuredAmount: data?.insuredAmount,
        deductibleAmount: data?.deductibleAmount,
        periodOfDeduction: data?.periodOfDeduction,
        numberOfBottles: data?.numberOfBottles,
        isDeductibleOnce: data?.isDeductibleOnce,
        balance: data?.balance,
        evidenceOfPayment: {
          file:
            updatedVendorDocuments[0]?.file || data?.evidenceOfPayment?.file,
          fileName: updatedVendorDocuments[0]?.fileName,
          documentType:
            updatedVendorDocuments[0]?.documentType ||
            data?.evidenceOfPayment?.documentType,
          contentType:
            updatedVendorDocuments[0]?.contentType ||
            data?.evidenceOfPayment?.contentType,
        },
      };

      if (data?.ServiceId === 1) {
        dataValues = {
          auxiliaryServiceTypeId: typeOfAuxiliaryService[0]?.id * 1,
          numberOfBottles: data?.numberOfBottles,
          rate: data?.rate,
          id: Number(id),
        };
      } else if (data?.ServiceId === 2) {
        dataValues = {
          id: Number(id),
          auxiliaryServiceTypeId: selectedAssetDetails?.id * 1,
          assetName: data?.assetName,
          percentageValue: data?.percentageValue,
          periodOfDeduction: data?.periodOfDeduction,
          insuredAmount: calculateInsuredAmount,
          deductibleAmount: calculatedDeductibleAmount,
          paymentMode: Number(data?.paymentMode),
          serialNumber: data?.serialNumber,
          registrationNumber: data?.registrationNumber,
          purchasedDate: data?.purchasedDate,
          isDeductibleOnce: data?.isDeductibleOnce,
          balance: data?.balance,
          evidenceOfPayment: {
            file:
              updatedVendorDocuments[0]?.file || data?.evidenceOfPayment?.file,
            fileName: updatedVendorDocuments[0]?.fileName,
            documentType:
              updatedVendorDocuments[0]?.documentType ||
              data?.evidenceOfPayment?.documentType,
            contentType:
              updatedVendorDocuments[0]?.contentType ||
              data?.evidenceOfPayment?.contentType,
          },
        };
      }

      dataValues = Object.fromEntries(
        Object.entries(dataValues).filter(
          ([_, value]) =>
            value !== null &&
            value !== undefined &&
            value !== "" &&
            (!Array.isArray(value) || value.length > 0)
        )
      ); 
      const res = await dispatch(UpdateAuxiliaryServiceRequest(dataValues));

      if (res?.payload?.successful === true) {
        navigate(`/dashboard/employee/auxiliary-service-request`);
        reset();
      } else if (res?.payload?.successful === false) {
        toast.error(res?.payload?.statusMessage || "Submission failed");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred.");
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(GetAuxiliaryServiceRequestById(id)); // Make sure 'id' is used here
    }
    dispatch(GetAllAuxiliaryServiceSetup(payloadAuxiliaryServiceSetup));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);

  // Conditional loading state
  if (isLoading) {
    return (
      <PageLayout title={"Auxiliary Request Details"} hasBack={true}>
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>Loading data, please wait...</p>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout title={"Edit Auxiliary Service Request"} hasBack={true}>
      <FormProvider {...formMethods}>
        <FormTemplate handleSubmit={handleSubmit(submit)}>
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Service Information
            </h4>
            {/* <FormSelect
              title={"Service Type"}
              camelCase={"ServiceId"}
              placeholder={"select"}
              disabled={"disabled"}
              array={serviceType.map((position, index) => (
                <option key={index} value={+position?.id}>
                  {position?.title}
                </option>
              ))}
            /> */}
            {updatedData?.auxiliaryServiceTypeId === 1 ? (
              <>
                {" "}
                {/* <FormInput
                  title={"Service Type"}
                  camelCase={"ServiceId"}
                  placeholder={""}
                  // type={"number"}
                  defaultValue={"CWAY"}
                  disabled={true}
                /> */}
                <div
                  style={{
                    width: "100%",
                    marginTop: "1rem",
                  }}
                >
                  <span
                    style={{
                      padding: "0.85rem",
                      backgroundColor: "#f8fbf8",
                      borderRadius: "0.5rem",
                      // color: var(--secondary-black);
                      fontWeight: "500",
                      width: "400px",
                      border: "1px solid #d9e9da",
                    }}
                  >
                    CWAY
                  </span>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    width: "100%",
                    marginTop: "1rem",
                  }}
                >
                  <span
                    style={{
                      padding: "0.85rem",
                      backgroundColor: "#f8fbf8",
                      borderRadius: "0.5rem",
                      // color: var(--secondary-black);
                      fontWeight: "500",
                      width: "400px",
                      border: "1px solid #d9e9da",
                    }}
                  >
                    INSURANCE
                  </span>
                </div>
              </>
            )}
          </section>

          {/* Conditional rendering based on Service Type */}
          {ServiceId === 1 ? (
            <section className={DashboardStyle.form_section}>
              <h4 className={DashboardStyle.form_section_title}>
                Request Details
              </h4>
              <div className={DashboardStyle.inputs_group}>
                <div>
                  <FormInput
                    title={"Number of Bottles"}
                    camelCase={"numberOfBottles"}
                    placeholder={"Enter number of bottles"}
                    type={"number"}
                  />
                  <FormInput
                    title={"Amount"}
                    camelCase={"amount"}
                    placeholder={"Enter amount"}
                    type={"number"}
                    value={amount}
                    disabled={true}
                    isOptional={true}
                  />
                </div>
                <div>
                  <FormInput
                    title={"Payment Deadline"}
                    camelCase={"paymentDeadline"}
                    type={"datetime-local"}
                    // disabled={true}
                    // defaultValue={formattedPaymentDeadline}
                    isOptional={true}
                  />
                </div>
              </div>
            </section>
          ) : (
            <>
              <section className={DashboardStyle.form_section}>
                <h4 className={DashboardStyle.form_section_title}>
                  Asset Information
                </h4>
                <div className={DashboardStyle.inputs_group}>
                  <div>
                    <FormSelect
                      title={"Asset Name"}
                      camelCase={"assetName"}
                      placeholder={"Enter Asset Name"}
                      array={typeOfAuxiliaryServiceInsurance?.map(
                        (position, index) => (
                          <option key={index} value={position?.assetName}>
                            {position?.assetName}
                          </option>
                        )
                      )}
                      moreRegister={{
                        onChange: (e) => {
                          const selectedAsset =
                            typeOfAuxiliaryServiceInsurance?.find(
                              (x) => x?.assetName === e?.target?.value
                            );
                          setSelectedAssetDetails(selectedAsset);
                        },
                      }}
                    />
                    <FormInput
                      title={"Serial Number"}
                      camelCase={"serialNumber"}
                      placeholder={"Enter Serial Number"}
                      type={"number"}
                    />
                  </div>
                  <div>
                    <FormInput
                      title={"Registration Number"}
                      camelCase={"registrationNumber"}
                      placeholder={"Enter Registration Number"}
                      type={"number"}
                    />
                    <FormInput
                      title={"Cost Of Asset"}
                      camelCase={"costOfAsset"}
                      placeholder={"Enter Cost Of Asset"}
                      type={"number"}
                    />
                  </div>
                  <div>
                    <FormInput
                      title={"Date of Purchase"}
                      camelCase={"purchasedDate"}
                      placeholder={"Enter Date of Purchase"}
                      type={"date"}
                    />
                  </div>
                </div>
              </section>
              <section className={DashboardStyle.form_section}>
                <h4 className={DashboardStyle.form_section_title}>
                  Insurance Details{" "}
                </h4>
                <div className={DashboardStyle.inputs_group}>
                  <div>
                    <FormSelect
                      title={"Mode of Payment"}
                      camelCase={"paymentMode"}
                      placeholder={"Enter Mode of Payment"}
                      array={paymentModes?.map((position, index) => (
                        <option key={index} value={Number(position?.value)}>
                          {position?.name}
                        </option>
                      ))}
                    />
                    <FormInput
                      title={"Insured Amount"}
                      camelCase={"insuredAmount"}
                      placeholder={"Enter Insured Amount"}
                      type={"number"}
                      disabled={true}
                      value={calculateInsuredAmount}
                      isOptional={true}
                    />
                  </div>
                  {(selectedPaymentMode === 1 || selectedPaymentMode === 2) && (
                    <div>
                      <FormInput
                        title={"Deductible Amount"}
                        camelCase={"deductibleAmount"}
                        placeholder={"Enter Deductible Amount"}
                        type={"number"}
                        isOptional={true}
                        value={calculatedDeductibleAmount}
                        disabled={true}
                      />
                      <FormInput
                        title={"Period of Deduction"}
                        camelCase={"periodOfDeduction"}
                        placeholder={"Enter Period of Deduction"}
                        type={"number"}
                        isOptional={true}
                        value={calculatePeriodOfDeduction}
                        disabled={true}
                      />
                    </div>
                  )}

                  {selectedPaymentMode === 2 && (
                    <div>
                      <FormInput
                        title={"Balance"}
                        camelCase={"balance"}
                        placeholder={"Enter Balance"}
                        type={"number"}
                        // isOptional={true}
                      />
                    </div>
                  )}

                  {(selectedPaymentMode === 1 || selectedPaymentMode === 2) && (
                    <div
                      style={{
                        display: "flex",
                        // flexDirection: "column",
                        gap: ".5rem",
                      }}
                    >
                      <CheckBox
                        title={"Deductible Once"}
                        camelCase={"isDeductibleOnce"}
                        value={watch("isDeductibleOnce")}
                      />
                      <label>Deductible Once</label>
                    </div>
                  )}
                </div>
              </section>
              <section className={DashboardStyle.form_section}>
                <h4 className={DashboardStyle.form_section_title}>
                  Documents Upload
                </h4>
                <div className={DashboardStyle.inputs_group_no_grid}>
                  <FormUploadComponent
                    documentList={documentList}
                    uploadFile={uploadFile}
                    setUploadFile={setUploadFile}
                    setVendorDocument={setVendorDocument}
                    vendorDocument={vendorDocument}
                  />
                </div>
              </section>
              <section className={DashboardStyle.form_section}>
                <h4 className={DashboardStyle.form_section_title}>
                  Documents <br /> Uploads
                </h4>
                <div
                  className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
                >
                  {vendorDocument?.length === 0 ? (
                    <p>No Record Available</p>
                  ) : (
                    <Table>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>File Name</th>
                          <th>File Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vendorDocument?.map?.((x, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{x?.file?.name || x?.fileName}</td>
                              <td style={{ textTransform: "uppercase" }}>
                                {x?.value || x?.fileName}
                              </td>
                              <td>
                                <TableActionsDownload
                                  file={x?.file || null}
                                  url={x?.fileUrl || null}
                                  actions={() =>
                                    removeListData({
                                      value: index,
                                      list: vendorDocument,
                                      setList: setVendorDocument,
                                    })
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  )}
                </div>
              </section>
            </>
          )}

          <div
            style={{ marginTop: "1rem" }}
            className={DashboardStyle.button_cage}
          >
            <SupportButtons
              width={"auto"}
              // onClick={() => setIsOpen(!isOpen)}
              className={DashboardStyle?.button_cage_weight_without_border}
            >
              No, Cancel
            </SupportButtons>
            <ActionButtons
              // isLoading={isLoading}
              // disabled={!isValid}
              width={"auto"}
              className={DashboardStyle?.button_cage_weight}
              bg="var(--primary-color)"
            >
              Update Request
            </ActionButtons>
          </div>
        </FormTemplate>
      </FormProvider>
    </PageLayout>
  );
}

export default UpdateAuxiliaryRequest;
